import { render } from "./Incidents.vue?vue&type=template&id=48519ab6&scoped=true"
import script from "./Incidents.vue?vue&type=script&lang=js"
export * from "./Incidents.vue?vue&type=script&lang=js"

import "./Incidents.vue?vue&type=style&index=0&id=48519ab6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48519ab6"]])

export default __exports__